import { render, staticRenderFns } from "./LienFeedback.vue?vue&type=template&id=0d0fb049"
import script from "./LienFeedback.vue?vue&type=script&lang=js"
export * from "./LienFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports